export enum AssetActionType {
  GET_ASSET_TYPES_LIST_REQUEST = 'GET_ASSET_TYPES_LIST_REQUEST',
  GET_ASSET_TYPES_LIST_SUCCESS = 'GET_ASSET_TYPES_LIST_SUCCESS',
  GET_ASSET_TYPES_LIST_FAIL = 'GET_ASSET_TYPES_LIST_FAIL',
  GET_ASSET_TYPE_REQUEST = 'GET_ASSET_TYPE_REQUEST',
  GET_ASSET_TYPE_SUCCESS = 'GET_ASSET_TYPE_SUCCESS',
  GET_ASSET_TYPE_FAIL = 'GET_ASSET_TYPE_FAIL',
  ADD_ASSET_TYPE_REQUEST = 'ADD_ASSET_TYPE_REQUEST',
  ADD_ASSET_TYPE_SUCCESS = 'ADD_ASSET_TYPE_SUCCESS',
  ADD_ASSET_TYPE_FAIL = 'ADD_ASSET_TYPE_FAIL',
  EDIT_ASSET_TYPE_REQUEST = 'EDIT_ASSET_TYPE_REQUEST',
  EDIT_ASSET_TYPE_SUCCESS = 'EDIT_ASSET_SUCCESS',
  EDIT_ASSET_TYPE_FAIL = 'EDIT_ASSET_FAIL',
  DELETE_ASSET_TYPE_REQUEST = 'DELETE_ASSET_REQUEST',
  DELETE_ASSET_TYPE_SUCCESS = 'DELETE_ASSET_SUCCESS',
  DELETE_ASSET_TYPE_FAIL = 'DELETE_ASSET_FAIL',

  GET_ASSET_TYPE_PROPERTIES_REQUEST = 'GET_ASSET_TYPE_PROPERTIES_REQUEST',
  GET_ASSET_TYPE_PROPERTIES_SUCCESS = 'GET_ASSET_TYPE_PROPERTIES_SUCCESS',
  GET_ASSET_TYPE_PROPERTIES_FAIL = 'GET_ASSET_TYPE_PROPERTIES_FAIL',
  ADD_ASSET_TYPE_PROPERTY_REQUEST = 'ADD_ASSET_TYPE_PROPERTY_REQUEST',
  ADD_ASSET_TYPE_PROPERTY_SUCCESS = 'ADD_ASSET_TYPE_PROPERTY_SUCCESS',
  ADD_ASSET_TYPE_PROPERTY_FAIL = 'ADD_ASSET_TYPE_PROPERTY_FAIL',
  EDIT_ASSET_TYPE_PROPERTY_REQUEST = 'EDIT_ASSET_TYPE_PROPERTY_REQUEST',
  EDIT_ASSET_TYPE_PROPERTY_SUCCESS = 'EDIT_ASSET_TYPE_PROPERTY_SUCCESS',
  EDIT_ASSET_TYPE_PROPERTY_FAIL = 'EDIT_ASSET_TYPE_PROPERTY_FAIL',
  DELETE_ASSET_TYPE_PROPERTY_REQUEST = 'DELETE_ASSET_TYPE_PROPERTY_REQUEST',
  DELETE_ASSET_TYPE_PROPERTY_SUCCESS = 'DELETE_ASSET_TYPE_PROPERTY_SUCCESS',
  DELETE_ASSET_TYPE_PROPERTY_FAIL = 'DELETE_ASSET_TYPE_PROPERTY_FAIL',
}
